// extracted by mini-css-extract-plugin
export default {"splash":"Splash_splash__xJ8JT","wave":"Splash_wave__TFP6+","animate":"Splash_animate__EAyob"};